<app-header-inner></app-header-inner>
<!-- Subheader Start -->
<div class="subheader text-center dark-overlay dark-overlay-2" style="background-image: url('assets/img/subheader.jpg')">
    <div class="container">
      <div class="subheader-inner">
        <h1>Blog Full Width</h1>
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="#">Home</a></li>
            <li class="breadcrumb-item"><a href="#">Blog</a></li>
            <li class="breadcrumb-item active" aria-current="page">Blog Full Width</li>
          </ol>
        </nav>
      </div>

    </div>
  </div>
  <!-- Subheader End -->

  <!-- Blog Posts Start -->
  <div class="section section-padding">

    <div class="blog-fw">
      <div class="row masonry">

        <!-- Post Start -->
        <div class="col-lg-3 masonry-item">
          <article class="post">
            <h3 class="post-title"> <a routerLink='/blog-single'>Our all new chicken pizza now available</a> </h3>
            <div class="post-meta">
              <span> <i class="far fa-calendar"></i> <a routerLink='/blog-single'>January 22, 2020</a> </span>
              <span> <i class="far fa-user"></i> <a href="#">Fredrick Flow</a> </span>
            </div>
            <div class="post-thumbnail">
              <a routerLink='/blog-single'><img src="assets/img/blog/6.jpg" alt="post thumbnail"></a>
            </div>
            <div class="post-desc">
              <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</p>
            </div>
            <a routerLink='/blog-single' class="read-more">Read More</a>
          </article>
        </div>
        <!-- Post End -->

        <!-- Post Start -->
        <div class="col-lg-3 masonry-item">
          <article class="post">
            <h3 class="post-title"> <a routerLink='/blog-single'>Changing the way thin crusts are made</a> </h3>
            <div class="post-meta">
              <span> <i class="far fa-calendar"></i> <a routerLink='/blog-single'>January 24, 2020</a> </span>
              <span> <i class="far fa-user"></i> <a href="#">Fredrick Flow</a> </span>
            </div>
            <div class="post-thumbnail">
              <a routerLink='/blog-single'><img src="assets/img/blog/2.jpg" alt="post thumbnail"></a>
            </div>
            <div class="post-desc">
              <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</p>
            </div>
            <a routerLink='/blog-single' class="read-more">Read More</a>
          </article>
        </div>
        <!-- Post End -->

        <!-- Post Start -->
        <div class="col-lg-6 masonry-item">
          <article class="post">
            <h3 class="post-title"> <a routerLink='/blog-single'>New cheese rolls are now available</a> </h3>
            <div class="post-meta">
              <span> <i class="far fa-calendar"></i> <a routerLink='/blog-single'>January 27, 2020</a> </span>
              <span> <i class="far fa-user"></i> <a href="#">Fredrick Flow</a> </span>
            </div>
            <div class="post-thumbnail">
              <a routerLink='/blog-single'><img src="assets/img/blog/3.jpg" alt="post thumbnail"></a>
            </div>
            <div class="post-desc">
              <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</p>
            </div>
            <a routerLink='/blog-single' class="read-more">Read More</a>
          </article>
        </div>
        <!-- Post End -->

        <!-- Post Start -->
        <div class="col-lg-6 masonry-item">
          <article class="post">
            <h3 class="post-title"> <a routerLink='/blog-single'>Rose flavored pizza is going crazy nowdays</a> </h3>
            <div class="post-meta">
              <span> <i class="far fa-calendar"></i> <a routerLink='/blog-single'>February 1, 2020</a> </span>
              <span> <i class="far fa-user"></i> <a href="#">Fredrick Flow</a> </span>
            </div>
            <div class="post-thumbnail">
              <a routerLink='/blog-single'><img src="assets/img/blog/4.jpg" alt="post thumbnail"></a>
            </div>
            <div class="post-desc">
              <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</p>
            </div>
            <a routerLink='/blog-single' class="read-more">Read More</a>
          </article>
        </div>
        <!-- Post End -->

        <!-- Post Start -->
        <div class="col-lg-3 masonry-item">
          <article class="post">
            <h3 class="post-title"> <a routerLink='/blog-single'>Career offerings now open, sign up today</a> </h3>
            <div class="post-meta">
              <span> <i class="far fa-calendar"></i> <a routerLink='/blog-single'>February 1, 2020</a> </span>
              <span> <i class="far fa-user"></i> <a href="#">Fredrick Flow</a> </span>
            </div>
            <div class="post-thumbnail">
              <a routerLink='/blog-single'><img src="assets/img/blog/7.jpg" alt="post thumbnail"></a>
            </div>
            <div class="post-desc">
              <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</p>
            </div>
            <a routerLink='/blog-single' class="read-more">Read More</a>
          </article>
        </div>
        <!-- Post End -->

        <!-- Post Start -->
        <div class="col-lg-3 masonry-item">
          <article class="post">
            <h3 class="post-title"> <a routerLink='/blog-single'>Cheese wheels can be the next thing</a> </h3>
            <div class="post-meta">
              <span> <i class="far fa-calendar"></i> <a routerLink='/blog-single'>February 1, 2020</a> </span>
              <span> <i class="far fa-user"></i> <a href="#">Fredrick Flow</a> </span>
            </div>
            <div class="post-thumbnail">
              <a routerLink='/blog-single'><img src="assets/img/blog/8.jpg" alt="post thumbnail"></a>
            </div>
            <div class="post-desc">
              <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</p>
            </div>
            <a routerLink='/blog-single' class="read-more">Read More</a>
          </article>
        </div>
        <!-- Post End -->

        <!-- Post Start -->
        <div class="col-lg-3 masonry-item">
          <article class="post">
            <h3 class="post-title"> <a routerLink='/blog-single'>Rose flavored pizza is going crazy nowdays</a> </h3>
            <div class="post-meta">
              <span> <i class="far fa-calendar"></i> <a routerLink='/blog-single'>February 1, 2020</a> </span>
              <span> <i class="far fa-user"></i> <a href="#">Fredrick Flow</a> </span>
            </div>
            <div class="post-thumbnail">
              <a routerLink='/blog-single'><img src="assets/img/blog/9.jpg" alt="post thumbnail"></a>
            </div>
            <div class="post-desc">
              <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</p>
            </div>
            <a routerLink='/blog-single' class="read-more">Read More</a>
          </article>
        </div>
        <!-- Post End -->

        <!-- Post Start -->
        <div class="col-lg-3 masonry-item">
          <article class="post">
            <h3 class="post-title"> <a routerLink='/blog-single'>Career offerings now open, sign up today</a> </h3>
            <div class="post-meta">
              <span> <i class="far fa-calendar"></i> <a routerLink='/blog-single'>February 1, 2020</a> </span>
              <span> <i class="far fa-user"></i> <a href="#">Fredrick Flow</a> </span>
            </div>
            <div class="post-thumbnail">
              <a routerLink='/blog-single'><img src="assets/img/blog/10.jpg" alt="post thumbnail"></a>
            </div>
            <div class="post-desc">
              <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</p>
            </div>
            <a routerLink='/blog-single' class="read-more">Read More</a>
          </article>
        </div>
        <!-- Post End -->

        <!-- Post Start -->
        <div class="col-lg-3 masonry-item">
          <article class="post">
            <h3 class="post-title"> <a routerLink='/blog-single'>Cheese wheels can be the next thing</a> </h3>
            <div class="post-meta">
              <span> <i class="far fa-calendar"></i> <a routerLink='/blog-single'>February 1, 2020</a> </span>
              <span> <i class="far fa-user"></i> <a href="#">Fredrick Flow</a> </span>
            </div>
            <div class="post-thumbnail">
              <a routerLink='/blog-single'><img src="assets/img/blog/11.jpg" alt="post thumbnail"></a>
            </div>
            <div class="post-desc">
              <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</p>
            </div>
            <a routerLink='/blog-single' class="read-more">Read More</a>
          </article>
        </div>
        <!-- Post End -->

        <!-- Post Start -->
        <div class="col-lg-3 masonry-item">
          <article class="post">
            <h3 class="post-title"> <a routerLink='/blog-single'>Changing the way thin crusts are made</a> </h3>
            <div class="post-meta">
              <span> <i class="far fa-calendar"></i> <a routerLink='/blog-single'>February 1, 2020</a> </span>
              <span> <i class="far fa-user"></i> <a href="#">Fredrick Flow</a> </span>
            </div>
            <div class="post-thumbnail">
              <a routerLink='/blog-single'><img src="assets/img/blog/12.jpg" alt="post thumbnail"></a>
            </div>
            <div class="post-desc">
              <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.</p>
            </div>
            <a routerLink='/blog-single' class="read-more">Read More</a>
          </article>
        </div>
        <!-- Post End -->

      </div>
    </div>

  </div>
  <!-- Blog Posts End -->
<app-footer></app-footer>